import { List } from 'foundations-components/transitional/components/List';
import I18n from 'I18n';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { trackStandaloneEvent } from '../usage-tracking/clients/usageTracker';
import { useCallback } from 'react';
import { HELP_DESK_APP_NAMESPACE } from '../usage-tracking/contants/namespaces';
import { MacroOption } from './MacroOption';
import { jsx as _jsx } from "react/jsx-runtime";
export const MacrosMenuList = ({
  macros,
  onSelectMacro
}) => {
  const handleDropdownToggle = useCallback(() => {
    trackStandaloneEvent(HELP_DESK_APP_NAMESPACE, 'Interaction', {
      action: 'Macro Menu Opened'
    });
  }, []);
  const handleSelectMacro = useCallback(macro => {
    trackStandaloneEvent(HELP_DESK_APP_NAMESPACE, 'Interaction', {
      action: 'Macro Selected'
    });
    onSelectMacro(macro);
  }, [onSelectMacro]);
  return /*#__PURE__*/_jsx(Dropdown, {
    buttonUse: "transparent",
    buttonText: I18n.text('composer-ui.macros-menu.title'),
    menuWidth: 300,
    buttonStyles: {
      paddingInlineStart: '0'
    },
    "data-test-id": "macros-menu-dropdown",
    onOpenComplete: handleDropdownToggle,
    children: /*#__PURE__*/_jsx(List, {
      children: macros.map(macro => /*#__PURE__*/_jsx(MacroOption, {
        macro: macro,
        handleSelectMacro: handleSelectMacro
      }, macro.id))
    })
  });
};
MacrosMenuList.displayName = 'MacrosMenuList';